import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
import React, { createContext, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import { usePopper } from "react-popper";
import { ThemePortalContext } from "@jutro/theme/internal";
import { popperPlacement } from "./types";
import styles from "./Popper.module.css";
var isElementChildOfPopper = function (popperId, element) {
    for (var current = element.closest("[".concat("data-popperid", "]")); null !== current;) {
      if (current.getAttribute("data-popperid") === popperId) return !0;
      var parentId = current.getAttribute("data-parentpopperid");
      if (null === parentId) return !1;
      current = document.querySelector("[".concat("data-popperid", "='").concat(parentId, "']"));
    }
    return !1;
  },
  nestedPopperContext = createContext(void 0);
export var Popper = function (_ref) {
  var _ref2,
    isOpen = _ref.isOpen,
    triggerElement = _ref.triggerElement,
    children = _ref.children,
    placement = _ref.placement,
    popperOptions = _ref.popperOptions,
    onClose = _ref.onClose,
    noPortal = _ref.noPortal,
    portalTargetElement = _ref.portalTargetElement,
    popperRef = useRef(null),
    _useState = useState(!1),
    _useState2 = _slicedToArray(_useState, 2),
    isDomReady = _useState2[0],
    setDomReady = _useState2[1],
    themePortalTarget = useContext(ThemePortalContext),
    _usePopper = usePopper(triggerElement, popperRef.current, function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
          _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }({
      placement: placement
    }, popperOptions)),
    popperStyles = _usePopper.styles.popper,
    attributes = _usePopper.attributes,
    update = _usePopper.update;
  useLayoutEffect(function () {
    isOpen && (null == update || update()), setDomReady(!0);
  }, [update, isOpen]);
  var parentPopperId = useContext(nestedPopperContext),
    _useState3 = useState(function () {
      return Math.floor(1e7 * Math.random()).toString();
    }),
    popperId = _slicedToArray(_useState3, 1)[0];
  !function (popperId, triggerElement, isOpen, onOutsideClick) {
    useEffect(function () {
      var handleClickOutside = function (event) {
        isOpen && event.target instanceof HTMLElement && (null != triggerElement && triggerElement.contains(event.target) || !isElementChildOfPopper(popperId, event.target) && isOpen && (null == onOutsideClick || onOutsideClick()));
      };
      return document.addEventListener("mousedown", handleClickOutside), function () {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [triggerElement, isOpen]);
  }(popperId, triggerElement, isOpen, onClose), function (popperId, triggerElement, isOpen, onEscKeyPressed) {
    useEffect(function () {
      var handleKeyPress = function (event) {
        if (isOpen) {
          var _triggerElement$focus,
            hasOpenedNestedPoppers = document.querySelector("[".concat("data-parentpopperid", "='").concat(popperId, "'][aria-hidden=false]"));
          "Escape" !== event.key || hasOpenedNestedPoppers || (null == onEscKeyPressed || onEscKeyPressed(), triggerElement instanceof HTMLElement && (null == triggerElement || null === (_triggerElement$focus = triggerElement.focus) || void 0 === _triggerElement$focus || _triggerElement$focus.call(triggerElement)));
        }
      };
      return document.addEventListener("keydown", handleKeyPress), function () {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [popperId, triggerElement, isOpen]);
  }(popperId, triggerElement, isOpen, onClose), function (popperId, isOpen, onBlurOutside) {
    var isClicking = useRef(!1);
    useEffect(function () {
      var handleBlur = function (event) {
          isClicking.current || isOpen && event.relatedTarget && (event.relatedTarget instanceof HTMLElement && isElementChildOfPopper(popperId, event.relatedTarget) || null == onBlurOutside || onBlurOutside());
        },
        handleClickStart = function () {
          isClicking.current = !0;
        },
        handleClickEnd = function () {
          isClicking.current = !1;
        };
      return document.addEventListener("mousedown", handleClickStart), document.addEventListener("mouseup", handleClickEnd), document.addEventListener("focusout", handleBlur), function () {
        document.removeEventListener("mousedown", handleClickStart), document.removeEventListener("mouseup", handleClickEnd), document.removeEventListener("focusout", handleBlur);
      };
    }, [popperId, isOpen]);
  }(popperId, isOpen, onClose);
  var popperClassName = cx(styles.popper, _defineProperty({}, styles.hidden, !isOpen)),
    popper = React.createElement("div", _extends({
      "aria-hidden": !isOpen,
      ref: popperRef,
      style: isOpen ? popperStyles : {
        transform: "scale(0) translateY(-1000px)"
      },
      className: popperClassName
    }, attributes.popper, (_defineProperty(_ref2 = {}, "data-popperid", popperId), _defineProperty(_ref2, "data-parentpopperid", parentPopperId), _ref2)), children);
  return React.createElement(nestedPopperContext.Provider, {
    value: popperId
  }, noPortal ? popper : createPortal(popper, null != portalTargetElement ? portalTargetElement : document.querySelector(isDomReady && themePortalTarget ? themePortalTarget : "body")));
};
Popper.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  triggerElement: PropTypes.instanceOf("undefined" != typeof window ? Element : Object),
  children: PropTypes.node,
  placement: PropTypes.oneOf(popperPlacement),
  popperOptions: PropTypes.shape({}),
  onClose: PropTypes.func,
  noPortal: PropTypes.bool,
  portalTargetElement: PropTypes.instanceOf("undefined" != typeof window ? HTMLElement : Object)
}, Popper.__docgenInfo = {
  description: "Creates popover near to referenced element\n\n@type {React.FC<PropTypes.InferProps<typeof PopperProps>>}\n\n@metadataType container",
  methods: [],
  displayName: "Popper",
  props: {
    isOpen: {
      type: {
        name: "bool"
      },
      required: !0,
      description: "Controls whether container should be hidden"
    },
    triggerElement: {
      type: {
        name: "instanceOf",
        value: "typeof window !== 'undefined' ? Element : Object"
      },
      required: !1,
      description: "Reference element for Popper.\nPopper will be positioned based on this element position."
    },
    children: {
      type: {
        name: "node"
      },
      required: !1,
      description: "Node to be rendered inside Popper"
    },
    placement: {
      type: {
        name: "enum",
        computed: !0,
        value: "popperPlacement"
      },
      required: !1,
      description: "Defines where container should show up"
    },
    popperOptions: {
      type: {
        name: "shape",
        value: {}
      },
      required: !1,
      description: "Additional options passed as third argument to usePopper hook\nList of options with descriptions: https://popper.js.org/docs/v2/constructors/#options"
    },
    onClose: {
      type: {
        name: "func"
      },
      required: !1,
      description: "Optional callback that's supposed to be triggered when container gets closed"
    },
    noPortal: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "If true, Popper will not be rendered inside React Portal.\nRendering Popper in React Portal is helpful if want to position a tooltip inside\nan overflow: hidden container that you want to make overflow."
    },
    portalTargetElement: {
      type: {
        name: "instanceOf",
        value: "typeof window !== 'undefined' ? HTMLElement : Object"
      },
      required: !1,
      description: "React Portal target element, preferably one of the top-level DOM elements.\nMust be unique, defaults to body element."
    }
  }
}, Popper.__docgenInfo = {
  componentName: "Popper",
  packageName: "@jutro/components",
  description: "Creates popover near to referenced element",
  displayName: "Popper",
  methods: [],
  actualName: "Popper",
  metadataType: "container",
  props: {
    isOpen: {
      type: {
        name: "bool"
      },
      required: !0,
      description: "Controls whether container should be hidden"
    },
    triggerElement: {
      type: {
        name: "instanceOf",
        value: "typeof window !== 'undefined' ? Element : Object"
      },
      required: !1,
      description: "Reference element for Popper.\nPopper will be positioned based on this element position."
    },
    children: {
      type: {
        name: "node"
      },
      required: !1,
      description: "Node to be rendered inside Popper"
    },
    placement: {
      type: {
        name: "enum",
        computed: !1,
        value: [{
          value: "'auto'",
          computed: !1
        }, {
          value: "'auto-end'",
          computed: !1
        }, {
          value: "'auto-start'",
          computed: !1
        }, {
          value: "'bottom'",
          computed: !1
        }, {
          value: "'bottom-end'",
          computed: !1
        }, {
          value: "'bottom-start'",
          computed: !1
        }, {
          value: "'left'",
          computed: !1
        }, {
          value: "'left-end'",
          computed: !1
        }, {
          value: "'left-start'",
          computed: !1
        }, {
          value: "'right'",
          computed: !1
        }, {
          value: "'right-end'",
          computed: !1
        }, {
          value: "'right-start'",
          computed: !1
        }, {
          value: "'top'",
          computed: !1
        }, {
          value: "'top-end'",
          computed: !1
        }, {
          value: "'top-start'",
          computed: !1
        }]
      },
      required: !1,
      description: "Defines where container should show up"
    },
    popperOptions: {
      type: {
        name: "shape",
        value: {}
      },
      required: !1,
      description: "Additional options passed as third argument to usePopper hook\nList of options with descriptions: https://popper.js.org/docs/v2/constructors/#options"
    },
    onClose: {
      type: {
        name: "func"
      },
      required: !1,
      description: "Optional callback that's supposed to be triggered when container gets closed"
    },
    noPortal: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "If true, Popper will not be rendered inside React Portal.\nRendering Popper in React Portal is helpful if want to position a tooltip inside\nan overflow: hidden container that you want to make overflow."
    },
    portalTargetElement: {
      type: {
        name: "instanceOf",
        value: "typeof window !== 'undefined' ? HTMLElement : Object"
      },
      required: !1,
      description: "React Portal target element, preferably one of the top-level DOM elements.\nMust be unique, defaults to body element."
    }
  }
};